module.exports = __webpack_public_path__ + "static/media/grocery_set_map.6c03166d.svg";